import { SortableAdapter } from "./adapters/SortableAdapter";

interface LiveSortableCallbacks {
    onStart: () => void;
    onEnd: (item: HTMLElement, moved: boolean) => void;
}

export class CmsLiveSortableAdapter {
    #sortable: SortableAdapter | null = null;

    constructor(
        private readonly container: HTMLElement,
        private readonly callbacks: LiveSortableCallbacks,
    ) {}

    mount(): void {
        this.destroy();
        this.#sortable = new SortableAdapter(this.container);
        this.#sortable.mount({
            animation: 160,
            handle: "[data-cms-live-drag-handle]",
            draggable: '[data-cms-editable-type="element"]',
            ghostClass: "admin-cms-live-editable--ghost",
            dragClass: "admin-cms-live-editable--drag",
            chosenClass: "admin-cms-live-editable--chosen",
            forceFallback: true,
            fallbackClass: "admin-cms-live-editable--fallback",
            onStart: () => this.callbacks.onStart(),
            onEnd: (event) => this.callbacks.onEnd(event.item as HTMLElement, event.oldIndex !== event.newIndex),
        });
    }

    destroy(): void {
        this.#sortable?.destroy();
        this.#sortable = null;
    }
}
